// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"84":"our-doctors","166":"patient-profile"}[chunkId] + "." + {"84":"7459ee82","166":"7459ee82"}[chunkId] + ".chunk.css";
};